import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 24px 24px 48px 24px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      padding: 16px 16px 32px 16px;
    }
  `}
`;

export const WrapperButton = styled.div`
  display: inline-flex;
  justify-content: flex-start;
`;

export const SkeletonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;
